var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getDefaultSlots, Draggable, canUseDOM } from '@progress/kendo-vue-common';
import { TreeListRow } from './TreeListRow';
function targetRowIndex(event, parent, currentDocument) {
  if (!event.originalEvent) {
    return -1;
  }
  var row = targetElement(event, 'tr', currentDocument);
  if (row) {
    var rows = parent ? parent.children : [];
    for (var i = 0; i < rows.length; i++) {
      if (rows[i] === row) {
        return i;
      }
    }
  }
  return -1;
}
function targetElement(event, closest, currentDocument) {
  var target = currentDocument ? currentDocument.elementFromPoint(event.clientX, event.originalEvent.clientY) : null;
  return closest && target ? target.closest(closest) : null;
}
var treelist = '.k-widget.k-grid';
/**
 * @hidden
 */
var TreeListDraggableRowVue2 = {
  props: __assign(__assign({}, TreeListRow.props), {
    clueProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }),
  // @ts-ignore
  emits: {
    press: null,
    drag: null,
    drop: null
  },
  created: function created() {
    this.allowDrop = false;
    this.dragged = null;
    this.draggedOver = null;
  },
  mounted: function mounted() {
    if (this.$el) {
      this.draggable = this.$refs.draggable;
    }
  },
  methods: {
    onPress: function onPress(event) {
      var element = this.draggable && this.draggable.element;
      if (element) {
        this.dragged = this.$props.level;
        this.$emit('press', event, element);
      }
    },
    onDrag: function onDrag(event) {
      var element = this.draggable && this.draggable.element;
      if (!canUseDOM) {
        return;
      }
      var ownerDocument = element ? element.ownerDocument : document;
      if (!ownerDocument) {
        return;
      }
      var dragged = this.dragged;
      if (element && dragged) {
        if (!event.isTouch) {
          event.originalEvent.preventDefault();
        }
        var hovered_1 = this.$props.levels[targetRowIndex(event, element.parentNode, ownerDocument)];
        this.draggedOver = hovered_1;
        this.allowDrop = hovered_1 ? !dragged.every(function (num, i) {
          return num === hovered_1[i];
        }) : Boolean(targetElement(event, treelist, ownerDocument));
        this.$emit('drag', {
          nativeEvent: event.originalEvent,
          dragged: dragged,
          draggedOver: hovered_1,
          draggedItem: this.$props.dataItem,
          clueProps: {
            visible: true,
            top: event.pageY + 10,
            left: event.pageX,
            text: element.innerText,
            allowDrop: this.allowDrop
          }
        });
      }
    },
    onRelease: function onRelease(event) {
      var element = this.draggable && this.draggable.element;
      if (element) {
        if (this.dragged) {
          var dragged = __spreadArray([], this.dragged, true);
          var draggedOver = this.draggedOver && __spreadArray([], this.draggedOver, true);
          this.dragged = null;
          this.draggedOver = null;
          var draggedItem = this.$props.dataItem;
          this.$emit('drop', {
            nativeEvent: event.originalEvent,
            dragged: dragged,
            draggedOver: draggedOver,
            draggedItem: draggedItem,
            clueProps: {
              allowDrop: this.allowDrop
            }
          });
          this.allowDrop = false;
        }
      }
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return (
      // @ts-ignore  function children
      h(Draggable, {
        onPress: this.onPress,
        on: this.v3 ? undefined : {
          "press": this.onPress,
          "drag": this.onDrag,
          "release": this.onRelease
        },
        onDrag: this.onDrag,
        onRelease: this.onRelease,
        ref: 'draggable'
      }, this.v3 ? function () {
        return [defaultSlot];
      } : [defaultSlot])
    );
  }
};
/**
 * @hidden
 */
var TreeListDraggableRow = TreeListDraggableRowVue2;
export { TreeListDraggableRow, TreeListDraggableRowVue2 };